<!--
  Read-only preview of the condition set of the selected assignment row. Editing happens in the
  navItem "Bedingungssätze" (sets are shared between assignments) — hence only the jump button.
-->
<div class="cp-provision-assignment-condition-preview surface-card border-1 surface-border border-round p-3">

    <div class="flex align-items-start justify-content-between gap-3 mb-3">
        <div class="flex flex-column gap-1">
            <span class="text-sm text-color-secondary">Bedingungen der Zuordnung „{{ assignmentName }}“</span>
            @if (conditionSetId) {
                <div class="flex align-items-center flex-wrap gap-2">
                    <i class="fa-regular fa-list-check text-color-secondary"></i>
                    <span class="font-medium">{{ conditionSetName }}</span>
                    @if (conditionSetAlias) {
                        <span class="text-sm text-color-secondary">({{ conditionSetAlias }})</span>
                    }
                </div>
            } @else {
                <span class="font-medium">{{ unconditionalLabel }}</span>
            }
        </div>
        <div class="flex align-items-center gap-2">
            @if (conditionSetId) {
                <p-button
                        label="Im Bedingungssatz öffnen"
                        icon="fa-regular fa-arrow-up-right-from-square"
                        [text]="true"
                        size="small"
                        (onClick)="onJump()">
                </p-button>
            }
            <p-button
                    icon="fa-regular fa-xmark"
                    [text]="true"
                    [rounded]="true"
                    severity="secondary"
                    size="small"
                    ariaLabel="Vorschau schließen"
                    pTooltip="Vorschau schließen"
                    (onClick)="onClose.emit()">
            </p-button>
        </div>
    </div>

    @if (!conditionSetId) {
        <p-message
                severity="info"
                styleClass="w-full"
                text="Kein Bedingungssatz hinterlegt — diese Zuordnung gilt für alle Verträge, sofern Priorität und Gültigkeit passen.">
        </p-message>
    } @else if (busy) {
        <div class="flex flex-column gap-2">
            <p-skeleton height="2rem"></p-skeleton>
            <p-skeleton height="2rem"></p-skeleton>
        </div>
    } @else if (loadFailed) {
        <div class="flex align-items-center gap-2">
            <p-message severity="error" styleClass="flex-1"
                       text="Die Bedingungen konnten nicht geladen werden.">
            </p-message>
            <p-button label="Erneut laden" icon="fa-regular fa-rotate-right" [outlined]="true"
                      size="small" (onClick)="onRetry()">
            </p-button>
        </div>
    } @else if (!rows.length) {
        <p-message
                severity="warn"
                styleClass="w-full"
                text="Dieser Bedingungssatz enthält keine Bedingungen — die Zuordnung greift daher nie.">
        </p-message>
    } @else {
        <div class="flex flex-column gap-2">
            @for (row of rows; track row.id) {
                <div class="flex align-items-start gap-3 p-2 border-1 surface-border border-round">
                    <span class="text-sm text-color-secondary w-3rem flex-shrink-0">{{ row.orderPriority }}</span>
                    <p-tag [value]="row.modeLabel" [severity]="row.modeSeverity" [icon]="row.modeIcon"
                           styleClass="flex-shrink-0"></p-tag>
                    <div class="flex flex-column gap-1 flex-1">
                        @if (row.criteria.length) {
                            <div class="flex flex-wrap gap-2">
                                @for (criterion of row.criteria; track criterion) {
                                    <p-chip [label]="criterion" styleClass="text-sm"></p-chip>
                                }
                            </div>
                        } @else {
                            <span class="text-sm">Alle Verträge (keine Einschränkung)</span>
                        }
                        @if (row.description) {
                            <span class="text-xs text-color-secondary">{{ row.description }}</span>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="flex align-items-start gap-2 mt-3">
            <i class="fa-regular fa-circle-info text-color-secondary mt-1"></i>
            <span class="text-xs text-color-secondary">
                Die Bedingungen werden nach Priorität geprüft; die <strong>erste zutreffende</strong>
                entscheidet — „Einschließen“ wendet die Zuordnung an, „Ausschließen“ nicht. Trifft
                keine Bedingung zu, gilt die Zuordnung nicht.
            </span>
        </div>
    }

</div>
